import { cva, type VariantProps } from 'class-variance-authority';
import * as React from 'react';

import { cn } from './lib/utils';

const spinnerVariants = cva('animate-spin', {
  variants: {
    size: {
      xs: 'h-4 w-4',
      sm: 'h-6 w-6',
      default: 'h-8 w-8',
      lg: 'h-10 w-10',
      xl: 'h-14 w-14',
    },
  },
  defaultVariants: {
    size: 'default',
  },
});

type SpinnerProps = React.ComponentProps<'svg'> & VariantProps<typeof spinnerVariants>;

function Spinner({ className, size = 'default', ...props }: SpinnerProps) {
  return (
    <svg
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      className={cn(spinnerVariants({ size }), className)}
      role="status"
      aria-label="Loading"
      {...props}
    >
      <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" opacity="0.25" />
      <path
        d="M12 2a10 10 0 0 1 10 10"
        stroke="currentColor"
        strokeWidth="4"
        strokeLinecap="round"
      />
    </svg>
  );
}

export { Spinner, spinnerVariants };
